import React, { useEffect } from 'react';
import '../styles/SmpForWomenPage/SmpForWomenPage.css';
import ConsultationForm from '../components/HomePage/ConsultationForm';
import Faq from '../components/HomePage/Faq';
import Footer from '../components/HomePage/Footer';
import Navbar from '../components/HomePage/Navbar';
import Home from '../components/SmpForWomenPage/Home';
import TreatmentsForWomen from '../components/SmpForWomenPage/TreatmentsForWomen';
import CompareChart from '../components/HomePage/CompareChart';
import { useSelector, useDispatch } from 'react-redux';
import { selectShowDialog, setShowDialog } from '../state/slices'
import { selectDialogTitle, setDialogTitle } from '../state/slices'
import { selectDialogDesc, setDialogDesc } from '../state/slices'
import { selectShowLoading } from '../state/slices'
import FloatingWhatsAppButton from '../components/FloatingWhatsAppButton';
import Spacer from '../components/Spacer';

function SmpForWomenPage() {
  const showDialog = useSelector(selectShowDialog);
  const showLoading = useSelector(selectShowLoading);
  const dialogTitle = useSelector(selectDialogTitle);
  const dialogDesc = useSelector(selectDialogDesc);
  const dispatch = useDispatch();
  return (
    <div style={{ backgroundColor: "#fafafa", scrollbarWidth: 'none' }}>
      <div className='sfw-space-between-navbar'></div>
      <Home></Home>
      <Spacer></Spacer>
      <TreatmentsForWomen></TreatmentsForWomen>
      <Spacer></Spacer>
      <ConsultationForm></ConsultationForm>
      <Spacer></Spacer>
      <CompareChart></CompareChart>
      <Spacer></Spacer>
      <Faq></Faq>
      <Spacer></Spacer>
      <Footer></Footer>
      <FloatingWhatsAppButton></FloatingWhatsAppButton>
      <Navbar></Navbar>
      {showLoading && (<div className="dialog-overlay">
        <div className="loading">
          <div className="spinner"></div>
        </div>
      </div>)}
      {showDialog && (<div className="dialog-overlay">
        <div className="dialog">
          <p style={{ fontWeight: 'bold' }}>{dialogTitle}</p>
          <p>{dialogDesc}</p>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
            <button style={{ backgroundColor: '#023273', color: 'white' }} onClick={() => {
              dispatch(setShowDialog(false));
            }}>Ok</button>
          </div>
        </div>
      </div>)}
    </div>
  );
}

export default SmpForWomenPage;
